export default __webpack_public_path__ + "static/media/julia3.6dc41677.jpg";